import { useContext } from "react";
import getClassName from "../../utilities/getClassName";
import poweredByContext from "../../store/PoweredByContext";
import { getIcon, getRawIcon } from "../../utilities/icon";
import { isShyMainSite } from "../../utilities/poweredBy";

const Loading = ({ big, loadingText, generic }) => {
    const poweredByCtx = useContext(poweredByContext);

    let className = ["loading"];

    const useShyLogoLoader = isShyMainSite() && !poweredByCtx.isPoweredBy && !generic && !poweredByCtx.siteChecking;

    if (big) {
        className.push("loading--big");
    }

    if (loadingText) {
        className.push("loading--with-text");
    }

    if (!useShyLogoLoader) {
        className.push("loading--spin");
    }

    if (generic) {
        className.push("loading--generic");
    }

    const icon = big ? getIcon("loading--big") : getIcon("loading");

    return (
        <>
            <div className={getClassName(className)}>
                {!useShyLogoLoader ? (
                    <>{getRawIcon(big ? "loading--big" : "loading")}</>
                ) : (
                    <>
                        <div
                            className="loading__image"
                            style={{
                                maskImage: `url(${icon})`,
                            }}
                        >
                            <img src={icon} alt="" />
                            {loadingText && <div className="loading__text">{loadingText}</div>}
                        </div>

                        <div className="loading__fill">
                            <div />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Loading;
